const SEARCH_TIRE_QUOTES = 'TIRE_QUOTES/SEARCH';

export const SEARCH_TIRE_QUOTES_REQUEST = `${SEARCH_TIRE_QUOTES}/REQUEST`;
export const SEARCH_TIRE_QUOTES_SUCCESS = `${SEARCH_TIRE_QUOTES}/SUCCESS`;

export const OPEN_TIRE_QUOTES_IMPORT_MODAL = `${SEARCH_TIRE_QUOTES}/OPEN_MODAL`;
export const CLOSE_TIRE_QUOTES_IMPORT_MODAL = `${SEARCH_TIRE_QUOTES}/CLOSE_MODAL`;
